import React from "react";
import AuthExperience from "../experience/AuthExperience";
import AuthEntryGate from "../identity/AuthEntryGate";
import { beginIdentityLogin, getAuthSwitchPath } from "../identity/identityClient";

export default function Login() {
  return (
    <AuthEntryGate>
      <AuthExperience
        onContinue={beginIdentityLogin}
        mode="login"
        productName="Clikkle Store"
        productHomeUrl="https://clikkle.com"
        productBrandPath="/images/clikkle/brand/logos/store-logo.png"
        signupPath={getAuthSwitchPath("signup")}
      />
    </AuthEntryGate>
  );
}
